import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import { BASE_API_URL } from "store/Me";
import getGuestDisplayName from "utils/getGuestDisplayName";

export default function LockGuests({ lockId }: { lockId: string }) {
  const { data, isError } = useGetLockGuests(lockId);

  if (isError) {
    return <div>Error loading guests</div>;
  }

  if (data) {
    if (data.length === 0) {
      return <div>No guests found</div>;
    }

    return (
      <div className="pb-5">
        <div className="overflow-hidden bg-white border rounded-lg shadow-sm border-slate-200">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left [&_th]:px-4 [&_th]:py-3 [&_td]:px-4 [&_td]:py-3">
              <thead className="text-xs font-semibold border-b border-slate-200 bg-slate-50 text-slate-500">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Valid From</th>
                  <th scope="col">Valid To</th>
                  <th scope="col">Deleted</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-100 text-slate-700 [&>tr:hover]:bg-slate-50">
                {data.map((guest) => (
                  <tr key={guest.id}>
                    <td>
                      <Link to={`/admin/guests/${guest.id}`}>
                        {getGuestDisplayName(guest.firstName, guest.lastName)}
                      </Link>
                      <div style={{ paddingTop: 4, fontSize: 12, color: "gray" }}>
                        {guest.id}
                      </div>
                    </td>
                    <td>{guest.email}</td>
                    <td>{new Date(guest.validFrom).toLocaleString()}</td>
                    <td>{new Date(guest.validTo).toLocaleString()}</td>
                    <td>{guest.deletedTimestamp ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return <div>loading...</div>;
}

interface LockGuestResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  validFrom: string;
  validTo: string;
  deletedTimestamp: string;
}

async function getLockGuests(lockId: string) {
  const response = await axios.get<LockGuestResponse[]>(
    `${BASE_API_URL}/api/Locks/${lockId}/guests`,
  );
  return response.data;
}

function useGetLockGuests(lockId: string) {
  return useQuery({
    queryKey: ["locks", "details", "guests", lockId],
    queryFn: () => getLockGuests(lockId),
  });
}
